<ng-container
  *ngIf="{
    totalUnavailable: totalUnavailable$ | async,
    totalAvailable: totalAvailable$ | async,
    isOwner: isOwner$ | async,
    isLoading: loading$ | async,
    products: products$ | async,
    groupedByCategory: groupedByCategory$ | async,
    showUnavailableProducts: showUnavailableProducts$ | async,
    allProductsLoaded: allProductsLoaded$ | async,
    isCommercialList: isCommercialList$ | async,
    list: list$ | async,
    isDraggable: isDraggable$ | async,
    isListDeleted: isListDeleted$ | async,
    totalProducts: totalProducts$ | async,
    productReferences: productReferences$ | async,
    isCommercialListWithMultipleDates:
      isCommercialListWithMultipleDates$ | async,
    isEpicShowConsumer: isEpicShowConsumer$ | async,
    showProductsAutocomplete: showProductsAutocomplete$ | async,
    categoryName: categoryName$ | async
  } as observables"
>
  <atx-infinite-scroll
    (scrolled)="onScroll()"
    [disabled]="observables.isEpicShowConsumer"
    atxFullscreen
    (fullscreenChanged)="isFullscreen = !isFullscreen"
    [class.with-fullscreen]="isFullscreen"
  >
    <epc-dynamic-elements-fluid-draggable-list-content
      [startWithRatio]="initialRatio$ | async"
      [groupedByCategory]="observables.groupedByCategory"
      [sortable]="
        observables.isOwner &&
        !observables.isCommercialList &&
        !observables.isListDeleted
      "
      [productReferences]="observables.products"
      (productSorted)="productSorted($event)"
    >
      <ng-container media>
        <ng-content></ng-content>
      </ng-container>

      <ng-container listItems>
        <ng-container
          *ngIf="
            !observables.isLoading && observables.totalProducts === 0;
            else hasProducts
          "
        >
          <atx-empty-placeholder
            class="empty-placeholder"
            [icon]="['fas', 'tag']"
          >
            <ng-container
              msg
              i18n="
                ProductLists|Product list has no
                products@@productsInListEmptyText"
            >
              This list has no products.
            </ng-container>

            <ng-container
              *ngIf="
                observables.isOwner &&
                !observables.isCommercialList &&
                !observables.isListDeleted
              "
            >
              <div
                class="d-flex flex-wrap justify-content-center align-items-center"
              >
                <button
                  class="btn btn-primary-transparent m-2"
                  i18n="
                    ProductLists|Add products manually@@addProductsManuallyText"
                  data-e2e="add-products-manually-button"
                  (click)="addProductsManually()"
                >
                  Add products manually
                </button>
                <a
                  class="d-none d-md-block btn btn-primary-transparent m-2"
                  [routerLink]="[
                    '/browse',
                    productListPath,
                    observables.list.id,
                    showProductsAutocomplete
                      ? productListEditPath
                      : bulkAddProductsPath
                  ]"
                  i18n="ProductLists|Add bulk products@@bulkAddProductsText"
                  data-e2e="Add-multiple-products"
                >
                  Add multiple products
                </a>
              </div>
            </ng-container>
          </atx-empty-placeholder>
        </ng-container>

        <ng-template #hasProducts>
          <ng-container
            *ngIf="!observables.isEpicShowConsumer; else epicShowConsumer"
          >
            <ng-container
              *ngFor="
                let product of observables.products;
                let i = index;
                trackBy: trackByFn
              "
            >
              <epc-dynamic-elements-category-header
                *ngIf="observables.groupedByCategory"
                [products]="observables.products"
                [index]="i"
                [categoryKey]="observables.categoryName"
              ></epc-dynamic-elements-category-header>

              <epc-product-card-base
                class="product-card"
                atxInfiniteScrollItem
                [deletable]="
                  observables.isOwner &&
                  !observables.isCommercialList &&
                  !observables.isListDeleted
                "
                [product]="product"
                [productReference]="
                  observables.productReferences?.get(product.productId)
                "
                [showCommercialListDate]="
                  observables.isCommercialListWithMultipleDates
                "
                [prices]="product.priceRanges"
                [showActions]="true"
                [isDraggable]="
                  observables.isDraggable && !observables.isListDeleted
                "
                [dragAndDropHandleTemplate]="dragAndDropHandle"
                [showAsUnavailable]="observables.showUnavailableProducts"
                [showUnavailableDeleteButton]="observables.isOwner"
                [type]="productSearchListMode$ | async"
                [isSearchV2Enabled]="true"
                (cardClick)="clickedProductCard(product, i)"
              >
              </epc-product-card-base>
            </ng-container>
            <ng-container *ngIf="observables.isLoading">
              <epc-product-card-skeleton
                *ngFor="let i of skeletons"
              ></epc-product-card-skeleton>
            </ng-container>
          </ng-container>

          <ng-template #epicShowConsumer>
            <atx-empty-placeholder
              class="empty-placeholder"
              [icon]="['fas', 'tag']"
            >
              <ng-container
                title
                i18n="
                  ProductLists|No saved products title@@noSavedProductsTitle"
              >
                You haven't saved any products
              </ng-container>
              <ng-container
                msg
                i18n="
                  ProductLists|No saved products message@@noSavedProductsMessage"
              >
                Save the products from the video by clicking the
                <fa-icon size="xs" [icon]="bookmarkIcon"></fa-icon> icon and
                they will appear here.
              </ng-container>
            </atx-empty-placeholder>
          </ng-template>
        </ng-template>
      </ng-container>
    </epc-dynamic-elements-fluid-draggable-list-content>
  </atx-infinite-scroll>
  <atx-pagination-loader
    *ngIf="
      !observables.isEpicShowConsumer ||
      (!observables.isLoading && observables.totalProducts === 0)
    "
    class="d-block mt-2 full-width"
    [allLoaded]="observables.allProductsLoaded"
    [nonEmpty]="true"
    [total]="observables.totalProducts"
    [loading]="observables.isLoading"
  ></atx-pagination-loader>

  <ng-template #dragAndDropHandle>
    <button
      class="dnd-icon-holder btn btn-light btn-round pointer-events-auto"
      [atxTooltip]="dragAndDropText"
      tooltipPlacement="bottom"
    >
      <fa-icon
        [icon]="['fas', 'arrows-up-down-left-right']"
        class="dnd-icon"
      ></fa-icon>
    </button>
  </ng-template>
</ng-container>
